import { API_BASE } from '../config';
import { Post } from '../types';
import { fetchJson } from './client';

export interface PostSummary {
  id: string;
  title: string;
  excerpt: string;
  published_at?: string | null;
}

export interface AdminPostSummary extends Post {
  published_at?: string | null;
}

export type AdminPostDetail = AdminPostSummary;

const withAuth = (token: string) => ({
  headers: {
    Authorization: `Bearer ${token}`,
  },
});

export const createPost = async (
  data: { title: string; content: string; excerpt: string },
  token: string,
): Promise<Post> => {
  return fetchJson<Post>(`${API_BASE}/posts`, {
    method: 'POST',
    ...withAuth(token),
    body: JSON.stringify(data),
  });
};

export const listPublishedPosts = async (limit: number, offset: number): Promise<PostSummary[]> => {
  return fetchJson<PostSummary[]>(`${API_BASE}/posts?limit=${limit}&offset=${offset}`);
};

export const listAdminPosts = async (
  limit: number,
  offset: number,
  token: string,
): Promise<AdminPostSummary[]> => {
  return fetchJson<AdminPostSummary[]>(`${API_BASE}/posts/all?limit=${limit}&offset=${offset}`, withAuth(token));
};

export const getPost = async (id: string): Promise<Post> => {
  return fetchJson<Post>(`${API_BASE}/posts/${id}`);
};

export const getAdminPost = async (id: string, token: string): Promise<AdminPostDetail> => {
  return fetchJson<AdminPostDetail>(`${API_BASE}/posts/${id}`, withAuth(token));
};

export const getPostBySlug = async (slug: string): Promise<Post> => {
  return fetchJson<Post>(`${API_BASE}/posts/slug/${slug}`);
};

export const publishPost = async (id: string, token: string): Promise<AdminPostSummary> => {
  return fetchJson<AdminPostSummary>(`${API_BASE}/posts/${id}/publish`, {
    method: 'PUT',
    ...withAuth(token),
  });
};

export const unpublishPost = async (id: string, token: string): Promise<AdminPostSummary> => {
  return fetchJson<AdminPostSummary>(`${API_BASE}/posts/${id}/unpublish`, {
    method: 'PUT',
    ...withAuth(token),
  });
};

export const deletePost = async (id: string, token: string): Promise<void> => {
  await fetchJson(`${API_BASE}/posts/${id}`, {
    method: 'DELETE',
    ...withAuth(token),
  });
};
